import QueryDB from "@/api/queryDB/common";
import { DropDown } from "@/components";
import { Spinner } from "@radix-ui/themes";
import BaseModalWindow from "@/components/BaseModalWindow/BaseModalWindow";
import { createToast } from "@/utils/toaster/createToast";
import React, { FC, useState } from "react";
import { ReactComponent as ThreeDotsIcon } from "../../../../assets/actions/more-vertical.svg";
import { ReportFormModal } from "@/components/ReportFormModal/ReportFormModal";
import { Button } from "@radix-ui/themes";

export const SinglePostSingleCommentDropDownActions: FC<{
  setIsDeleted: React.Dispatch<React.SetStateAction<boolean>>;
  setIsEditComment: React.Dispatch<React.SetStateAction<boolean>>;
  belongsToCurrentUser: boolean;
  commentId: string;
  postId: string;
  currUserSlug: string;
  isAuthorized?: boolean;
}> = ({
  setIsDeleted,
  setIsEditComment,
  belongsToCurrentUser,
  commentId,
  postId,
  currUserSlug,
  isAuthorized,
}) => {
  const [confirmModalOpen, setConfirmModalOpen] = useState<boolean>(false);
  const [deleting, isDeleting] = useState<boolean>(false);
  const [reportModal, setReportModal] = useState<boolean>(false);
  return (
    <>
      <BaseModalWindow
        show={confirmModalOpen}
        closeModal={() => {
          setConfirmModalOpen(false);
        }}
        title="Delete this comment?"
      >
        <div className="modal__delete">
          <div className="delete-comment">
            <div className="delete-comment__body">
              <p>Are you sure you want to delete this comment?</p>
            </div>
            <div className="delete-comment__actions">
              <Button variant="soft" onClick={() => setConfirmModalOpen(false)}>
                Keep
              </Button>

              <Button
                disabled={deleting}
                onClick={async () => {
                  if (deleting) {
                    return;
                  }
                  if (!commentId || (!belongsToCurrentUser && !isAuthorized)) {
                    return setConfirmModalOpen(false);
                  }

                  isDeleting(true);
                  setIsDeleted(true);
                  await QueryDB.deleteDoc(`posts/${postId}/comments`, commentId)
                    .then(() => {
                      createToast({
                        type: "info",
                        message: "Comment deleted.",
                      });
                    })
                    .catch((err) => {
                      setIsDeleted(false);
                      createToast({
                        type: "error",
                        message: "Comment failed to delete, comment restored.",
                      });
                    });
                  setConfirmModalOpen(false);
                  isDeleting(false);
                  return null;
                }}
              >
                {deleting ? <Spinner /> : "Delete"}
              </Button>
            </div>
          </div>
        </div>
      </BaseModalWindow>

      {/* Report modal */}
      <ReportFormModal
        show={reportModal}
        closeModal={() => {
          setReportModal(false);
        }}
        children={""}
        reportFrom="comment"
        reportItemId={commentId}
      />

      {/* Actions */}
      {belongsToCurrentUser || isAuthorized ? (
        <DropDown logo={<ThreeDotsIcon />}>
          {belongsToCurrentUser || isAuthorized ? (
            <a
              className="dropdown__option"
              onClick={(e) => {
                e.preventDefault();
                setConfirmModalOpen(true);
              }}
            >
              Delete
            </a>
          ) : (
            ""
          )}

          {belongsToCurrentUser && (
            <a
              className="dropdown__option"
              onClick={(e) => {
                setIsEditComment(true);
                e.preventDefault();
              }}
            >
              Edit
            </a>
          )}
        </DropDown>
      ) : (
        ""
      )}

      {!belongsToCurrentUser && !isAuthorized && (
        <DropDown logo={<ThreeDotsIcon />}>
          <a
            className="dropdown__option"
            onClick={(e) => {
              e.preventDefault();
              setReportModal(true);
            }}
          >
            Report
          </a>
        </DropDown>
      )}
    </>
  );
};
